import React, { Component } from "react";
import PropTypes from 'prop-types';
// import Graphics from "./components/graphics/Graphics";
import { Graphics } from './components/Graphics';

// import Controls from "components/pipette/Controls";
// import MoveMenu from "./MoveMenu"


import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../toast/Toast";

import "./RotorAdapters.scss";
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';


export class RotorAdapters extends Component {
constructor(props) {
  super(props);

  this.state = {}

  const interactions = (heldObj, target) => {
    //Don't run if this RotorAdapters not the held object
    if(heldObj.type !== "RotorAdapters" || heldObj.id !== this.props.id){
      return null;
    }
    if (target === undefined || target === null) {
      this.props.setRotorAdaptersOnShelf({
        id: this.props.id,
        onShelf: false
      });
      return null;
    }

          // All Microcentrifuge interactions
          if (target.type === "Microcentrifuge") {
            //Get the targeted TipBox
            const targetMicrocentrifuge = this.props.interactionProps.microcentrifuge[target.id - 1]
            if (targetMicrocentrifuge.isOpen) {

                this.props.setRotorAdaptersInScene({
                  id: this.props.id,
                  inScene: false,
                });

                this.props.setRotorAdaptersOnShelf({
                  id: this.props.id,
                  onShelf: false
                });

                this.props.onMicrocentrifugeInsertRotor({
                  id: target.id,
                  itemId: this.props.id
                })

              // Reset the tube position to a zero transform
              heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"

            } else {
              //Alert - open centrifuge
              this.makeToast("WARNING", "You must open the microcentrifuge first.", "Microcentrifuge is closed!")
            }
          }
          //  else if(target.type === "Shelf") {

          //   this.props.setRotorAdaptersOnShelf({
          //     id: this.props.id,
          //     onShelf: true
          //   });

          //   this.props.setRotorAdaptersHeld({
          //     id: this.props.id,
          //     held: false
          //   });

          // } else {

          //   this.props.setRotorAdaptersOnShelf({
          //     id: this.props.id,
          //     onShelf: false
          //   });

          //   this.props.setRotorAdaptersHeld({
          //     id: this.props.id,
          //     held: false
          //   });
          // }

    //All Microcentrifuge interactions
    // if (target.type === "Microcentrifuge") {
    //   //Get the targeted TipBox
    //   const targetId = target.id
    //   // const targetMicrocentrifuge = this.props.interactionProps.transilluminator[targetId - 1]
    //   const targetMicrocentrifuge = this.props.interactionProps.microcentrifuge[targetId - 1]

    //   if(targetMicrocentrifuge.isOpen) {

    //       this.props.setRotorAdaptersInScene({
    //         id: this.props.id,
    //         containsRotorAdapters: false,
    //       });
    //       // this.props.setRotorAdaptersInMicrocentrifuge({
    //       //   id: targetId,
    //       //   containsRotorAdapters: true,
    //       // });

    //       this.props.setRotorAdaptersOnShelf({
    //         id: this.props.id,
    //         onShelf: false
    //       });

    //       this.props.onMicrocentrifugeInsertItem({
    //         id: target.id,
    //         itemId: this.props.id
    //       })


    //   } else if(!targetMicrocentrifuge.open){

    //     this.makeToast("WARNING", "You must open the microcentrifuge first.", "Microcentrifuge is closed!")
    //   } else {
    //     return null;
    //   }
    // } else if(target.type === "Shelf") {

    //   this.props.setRotorAdaptersOnShelf({
    //     id: this.props.id,
    //     onShelf: true
    //   });

    //   this.props.setRotorAdaptersHeld({
    //     id: this.props.id,
    //     held: false
    //   });

    // } else {

    //   this.props.setRotorAdaptersOnShelf({
    //     id: this.props.id,
    //     onShelf: false
    //   });

    //   this.props.setRotorAdaptersHeld({
    //     id: this.props.id,
    //     held: false
    //   });
    // }
    //All RotorAdaptersBox interactions
    // if (target.type === "GelBox") {
    //   //Get the targeted TipBox
    //   const rotorAdaptersID = target.id
    //   const targetRotorAdaptersBox = this.props.interactionProps.gelBoxes[rotorAdaptersID - 1]

    //   if(targetRotorAdaptersBox.open) {

    //     //Tip Box open - attach tip
    //     if (!targetRotorAdaptersBox.containsRotorAdapters) {
    //       //No tip attached - can attach new tip

    //       this.props.setRotorAdaptersInScene({
    //         id: this.props.id,
    //         containsRotorAdapters: false,
    //       });
    //       this.props.setRotorAdaptersInBox({
    //         id: rotorAdaptersID,
    //         containsRotorAdapters: true,
    //       });
    //       this.props.setRotorAdaptersOnShelf({
    //         id: this.props.id,
    //         onShelf: false
    //       });

    //     } else {
    //       //Alert - pipette already has a tip attached
    //       this.makeToast("WARNING", "The RotorAdapters box already has a RotorAdapters inside.", "RotorAdapters box full!")
    //     }
    //   } else if(!targetRotorAdaptersBox.open){

    //     this.makeToast("WARNING", "You need to open the lid of the RotorAdapters box fist.", "RotorAdapters box closed!")
    //   } else {
    //     return null;
    //   }
    // } else if(target.type === "Shelf") {

    //   this.props.setRotorAdaptersOnShelf({
    //     id: this.props.id,
    //     onShelf: true
    //   });

    //   this.props.setRotorAdaptersHeld({
    //     id: this.props.id,
    //     held: false
    //   });

    // } else {

    //   this.props.setRotorAdaptersOnShelf({
    //     id: this.props.id,
    //     onShelf: false
    //   });

    //   this.props.setRotorAdaptersHeld({
    //     id: this.props.id,
    //     held: false
    //   });
    // }
  }

  Object.defineProperty(interactions, 'name', {value: ('rotorAdapters_interactions_'+this.props.id), configurable: true});
  this.props.pushInteractions([interactions]);
}

componentWillMount() {
  this.props.createRotorAdapters({
    props: this.props.defaultProps,
  });
}

makeToast = (type, msg, title) => {
  let color = "";
  if (type === "HINT") {
    color = colors.yellow1;
  } else {
    color = colors.red1;
  }

  toast(<Toast type={type} msg={msg} title={title} />,{
    className: css({
      border: "2px solid "+color,
      borderRadius: "6px",
      marginLeft: "-200px",
      minWidth: "400px"
    }),
    progressClassName: css({
      background: color
    }),
    position: "top-center",
    autoClose: 5000,
  });
}

showControls = ()=> {
  this.props.hideAllControls();
  this.props.setRotorAdaptersControlVisibility({id: this.props.id, controlsVisible: true});
}

rotorAdaptersSelected = (e) => {

  if(!this.props.controlsVisible){
      this.showControls()
  }

  this.props.setRotorAdaptersHeld({
    id: this.props.id,
    held: true,
  })

  // this.props.setSolutionHeld({
  //   id: this.props.id,
  //   held: true,
  // });
  this.props.setHeldObject({
    id: this.props.id,
    type: "RotorAdapters",
    htmlObj: e.target,
  });

}

rotorAdaptersUnselected = (e) => {
  this.props.setRotorAdaptersHeld({
    id: this.props.id,
    held: false,
  })
}

showMoveMenu = e => {
  this.props.setMoveMenu({
    type: this.props.type,
    connect: this.props.id
  });
  this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
};

render(){
  return (
      <ul style={{ position: 'absolute' ,display:(!this.props.inScene)?'none':null, zIndex: (this.props.controlsVisible)?99:null }}>
         <li
            onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.rotorAdaptersSelected() } }
            onDragStart={(e) => this.rotorAdaptersSelected(e)}
            onDragEnd={(e) => this.rotorAdaptersUnselected(e)}
            draggable
            tabIndex={0}
            id={"RotorAdapters_"+this.props.id}
            className = {"RotorAdapters draggable droptarget"+ this.props.id}
             style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}
             >
            <p className="label" aria-hidden="true">{'#'+this.props.id + ' ' + this.props.type}</p>
            <Graphics id={this.props.id}/>
          </li>
       </ul>
    );
  }
}


RotorAdapters.propTypes = {
  createRotorAdapters: PropTypes.func,
}

RotorAdapters.defaultProps = {

}
